import { render } from "./Step2Student.vue?vue&type=template&id=1577c1de"
import script from "./Step2Student.vue?vue&type=script&lang=js"
export * from "./Step2Student.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__